/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const chosenCampaignAddonDataSchema = z.object({
	price: z.number(),
})

export type ChosenCampaignAddonDataSchema = z.infer<typeof chosenCampaignAddonDataSchema>
